import { Component, Input } from '@angular/core';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoEventRegistrantlistComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-registrantlist',
  templateUrl: 'co-event-registrantlist.html'
})


export class CoEventRegistrantlistComponent {
  @Input() registrants: Array<any>;
  checkedIn: number = 0;
  numberOfRegistrants: number = 0;

  constructor(private eventsProvider: EventsProvider, private sounds : SoundsProvider) {

  }

  ngOnChanges(){
    this.setupRegistrants();
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  setupRegistrants() {
    if(typeof(this.registrants) !== "undefined" && this.registrants.length > 0){
      this.numberOfRegistrants = this.registrants.length;
      this.registrants.forEach((registrant) => {
        registrant.registrationTime = moment(registrant.registrationTime).format("MMM DD, YYYY - hh:mma")
        if(registrant.patronCheckedIn){
          this.checkedIn++;
        }
      });
    }
  }

  updateCheckIn(registrantIndex) {
    let registrant: any = null;
    if(registrantIndex >= 0){
      registrant = this.registrants[registrantIndex];
    }
    //console.log('the registrant', registrant)
    registrant.patronCheckedIn = !registrant.patronCheckedIn;
    if(registrant.patronCheckedIn){
      this.checkedIn++;
    } else {
      this.checkedIn--;
    }

    let checkInObj = {
      registrationId: registrant.registrationId,
      checkedIn: registrant.patronCheckedIn
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/co-event-registrantlist/co-event-registrantlist.ts